<div class="recurso-campanha-form">
    <div class="card {{tipo.cardCssClass}}" *ngFor="let tipo of tipos">
        <div class="card-header"
            [style.top]="cardHeaderStickyTop">
            <a class="collapse-link" (click)="toggleCollapse(tipo)"
                tabindex="-1">
                <i class="fas fa-caret-down" aria-hidden="true" *ngIf="!tipo.isCollapseOpened"></i>
                <i class="fas fa-caret-up" aria-hidden="true" *ngIf="tipo.isCollapseOpened"></i>
                {{tipo.nomePlural}}
            </a>

            <span class="badge badge-tipo-total">
                {{tipo.recursos.length | decimalFormat: 1:0:0}}
            </span>
        </div>

        <div class="collapse show" id="collapse_{{tipo.id}}">
            <div class="table-responsive">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th class="col-options" *ngIf="canEdit"></th>
                            <th class="col-recurso">Recurso</th>
                            <th class="col-anotacao">Anotação</th>
                            <th class="col-valor text-right">Valor</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let recurso of tipo.recursos; let index = index">
                            <td class="col-options" *ngIf="canEdit">
                                <a class="btn btn-link btn-link-delete p-0" (click)="delete(tipo, index)" title="Excluir recurso">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>
                            <td class="col-recurso">
                                <sgt-recurso-campanha-select
                                    [somenteAtivos]="true"
                                    [tipoFilter]="tipo.id"
                                    [idAreaFilter]="idArea"
                                    [(ngModel)]="recurso.idRecursoCampanha"
                                    [(recursoCampanha)]="recurso.recursoCampanha"
                                    name="recurso_{{tipo.id}}_{{index}}"
                                    id="recurso_{{tipo.id}}_{{index}}"
                                    #recursoModel="ngModel"
                                    required="required"
                                    [disabled]="!canEdit">
                                </sgt-recurso-campanha-select>
                                <sgt-form-control-error
                                    *ngIf="recursoModel.errors && recursoModel.errors.required && recursoModel.dirty"
                                    msgError="O recurso é obrigatório">
                                </sgt-form-control-error>
                            </td>
                            <td class="col-anotacao">
                                <textarea class="form-control" [(ngModel)]="recurso.anotacao"
                                    name="anotacao_{{tipo.id}}_{{index}}" id="anotacao_{{tipo.id}}_{{index}}" rows="1" sgtAutosize
                                    [disabled]="!canEdit" [readonly]="!canEdit">
                                </textarea>
                            </td>
                            <td class="col-valor text-right">
                                <sgt-decimal2
                                    [(ngModel)]="recurso.valor"
                                    (ngModelChange)="onChangeRecursoValor(tipo)"
                                    #valorTotalModel="ngModel"
                                    [ngControl]="valorTotalModel"
                                    name="valorTotal_{{tipo.id}}_{{index}}"
                                    id="valorTotal_{{tipo.id}}_{{index}}"
                                    [disabled]="!canEdit"
                                    [readonly]="!canEdit">
                                </sgt-decimal2>
                            </td>
                        </tr>
                        <tr *ngIf="!tipo.recursos || tipo.recursos.length === 0">
                            <td colspan="4" class="text-center">
                                <i class="fas fa-info" aria-hidden="true"></i> Nenhum {{tipo.nome}} adicionado
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card-footer">
            <a class="btn btn-link btn-sm p-0" (click)="insert(tipo)" title="Novo {{tipo.nome}}" *ngIf="canEdit">
                <i class="fas fa-plus"></i> Novo {{tipo.nome}}
            </a>

            <span class="badge badge-tipo-total">
                {{tipo.valorTotal | currencyFormat: 1:2:2}}
            </span>
        </div>
    </div>

    <div class="row" *ngIf="isShowValorTotal">
        <div class="form-group col-12 col-md-4 col-xl-3">
            <label class="col-form-label">Valor Total dos Recursos</label>
            <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">R$</span>
                </div>
                <input type="text" class="form-control text-right" value="{{valorTotal | decimalFormat: 1:2:2}}" disabled="disabled" readonly="readonly">
            </div>
            <p class="form-text text-muted" *ngIf="valorTotalHelpText">
                {{valorTotalHelpText}}
            </p>
        </div>
    </div>
</div>
